module.exports = __webpack_public_path__ + "__assets__/img/nav-image.82bff1eb.png";